export default "//static.tradera.net/touchweb/static/output/images/google-play-badge-sv.7a7fbfb4.svg";